import './Corporate.scss';
import { useContext } from 'react';
import {DataContext } from '../../DataContext';

function Corporate() {
  const {navData} = useContext(DataContext);

  return (
    <div className="corporate">
      <nav className="corporate__nav" data-editable="footerLinks" aria-label="nav links">
        {navData && navData.corporate.map((navItem, index) => (
          <a
            key={`corporate-${index}`}
            href={
              navItem.url.includes('https') ? navItem.url : `https://www.cnn.com/${navItem.url}`
            }
            className="corporate__nav-link"
          >
            {navItem.title}
          </a>
        ))}
      </nav>
      <p className="corporate__copyright" data-editable="copyrightText">
        © {new Date().getFullYear()} Cable News Network. A Warner Bros. Discovery Company.{' '}
        <span className="linebreak">All Rights Reserved.</span>
        <br /> CNN Sans ™ &amp; © 2016 Cable News Network.
      </p>
    </div>
  );
}

export default Corporate;
